<template>
  <a
    :href="`https://www.facebook.com/share.php?u=${url}`"
    class="share"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src="@/assets/fb-logo.svg" alt="分享到 Facebook" />
  </a>
</template>

<script>

import { brand } from '../../content'

export default {
  name: 'UiShareFacebook',
  data() {
    return {
      url: `https://www.mirrormedia.mg/campaigns/whisky2021-${brand}/index.html`,
    }
  },
}
</script>

<style lang="scss" scoped>
.share {
  display: block;
  width: 36px;
}
</style>
